import { CalibrationConfirmInvoiceDeviceModel } from '../Interface/CalibrationConfirmInvoice_Interface';

export function buildCalibrationFactorRows(
  details: CalibrationConfirmInvoiceDeviceModel[]
): CalibrationConfirmInvoiceDeviceModel[] {
  const groups = new Map<string, CalibrationConfirmInvoiceDeviceModel[]>();

  for (const detail of details || []) {
    const key = [
      getDeviceGroupIdentity(detail),
      // Keep descriptions attached to the exact physical detail even in grouped invoices.
      detail.confirmInvoiceDescription?.trim() ? `detail:${detail.calibrationDetailId}` : '',
      toNumber(detail.tariff),
      toNumber(detail.incRailModir),
      toNumber(detail.incRail),
      toNumber(detail.incRailPercent)
    ].join('|');
    const group = groups.get(key) || [];
    group.push(detail);
    groups.set(key, group);
  }

  return Array.from(groups.values()).map(group => {
    const first = group[0];
    return {
      ...first,
      count: group.length,
      deviceCode: joinDistinct(group.map(item => item.deviceCode)),
      serial: joinDistinct(group.map(item => item.serial)),
      priceDescription: joinDistinct(group.map(item => item.priceDescription)),
      description: joinDistinct(group.map(item => item.description)),
      descriptionExpert: joinDistinct(group.map(item => item.descriptionExpert))
    };
  });
}

function getDeviceGroupIdentity(item: CalibrationConfirmInvoiceDeviceModel): string {
  const letterDeviceId = toNumber(item.letterDeviceId);
  if (letterDeviceId > 0) {
    return `letter-device:${letterDeviceId}`;
  }

  // GetDetail does not currently expose devicePersianId/deviceId. This
  // fallback is used only when the preferred LetterDeviceId is unavailable.
  return [
    'device-fallback',
    item.deviceName || '',
    item.deviceTitle || '',
    toNumber(item.locationId),
    toNumber(item.tariff),
    toNumber(item.incRailModir),
    toNumber(item.incPercentModir)
  ].join(':');
}

function joinDistinct(values: Array<string | null | undefined>): string {
  const distinct = values
    .map(value => String(value || '').trim())
    .filter((value, index, all) => !!value && all.indexOf(value) === index);
  return distinct.length ? distinct.join('، ') : '-';
}

function toNumber(value: number | null | undefined): number {
  const numericValue = Number(value);
  return isFinite(numericValue) ? numericValue : 0;
}
